module.exports = __webpack_public_path__ + "img/icn-chinese.87338d35.svg";